<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert" v-if="alert_success === true">เพิ่มข้อมูลเรียบร้อย !</v-alert>
        <v-alert type="error" class="alert" v-if="alert_danger === true">ลบข้อมูลเรียบร้อย !</v-alert>
      </v-slide-x-reverse-transition>
      <header_promotion_name :img_header="header_image" header="การแก้ไขสินค้าคละ" :promotion_code="header_list.name" link_back="stock/promotion_stock/promotionassorted"/>
      <v-card elevation="6">
        <v-form ref="update" @submit.prevent="update_data">
          <div class="grid_half">
            <div class="pa-2">
              <div class="mt-4">
                <v-img height="200" max-width="200" v-if="header_list.pic === ''" :lazy-src="img_holder" :src="img_holder" class="preview mx-auto"></v-img>
                <v-img height="200" max-width="200" v-if="header_list.pic !== ''" :lazy-src="img_holder" :src="header_list.pic" class="preview mx-auto"></v-img>
              </div>
              <div class="ml-3 mr-3">
                <v-file-input color="#86bc3a" label="รูปภาพสินค้า" prepend-icon="mdi-camera" hide-details="auto" v-model="pro_pic_name" @change="onFileChange"></v-file-input>
              </div>
            </div>
            <div class="pa-2">
              <div class="grid_list">
                <div class="ml-3 mt-6 mr-1">
                  <v-text-field color="#86bc3a" label="ชื่อโปรโมชั่น" :rules="[v => !!v || 'กรุณากรอกชื่อโปรโมชั่น']" v-model="header_list.name" hide-details="auto" required outlined></v-text-field>
                </div>
                <div class="ml-3 mt-6 mr-1">
                  <v-menu ref="menu_date" v-model="menu_date" :close-on-content-click="false" :return-value.sync="date" transition="scale-transition" offset-y min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field color="#86bc3a" v-model="date" label="วันที่สิ้นสุดโปรโมชั่น (วัน/เดือน/ปี)" :rules="[v => !!v || 'กรุณากรอกวันที่สิ้นสุดโปรโมชั่น']" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" outlined></v-text-field>
                    </template>
                    <v-date-picker locale="TH" color="#86bc3a" @change="diffDateTH(dateEN)" v-model="dateEN" :min="start_date" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="selectDate()">
                        ตกลง
                      </v-btn>
                      <v-btn text color="primary" @click="menu_date = false">
                        ยกเลิก
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </div>
                <div class="ml-3 mr-1">
                  <v-text-field color="#86bc3a" @keypress="isOnlyNumber($event)" v-model="header_list.qty_per_set" :rules="[v => !!v || 'กรุณากรอกจำนวนในการคละ']" label="จำนวนในการคละ" hide-details="auto" required outlined></v-text-field>
                </div>
                <div class="ml-3 mr-1">
                  <v-text-field color="#86bc3a" @keypress="isCurrency($event, header_list.price_per_set)" v-model="header_list.price_per_set" label="ราคาขาย(ต่อชุด)" :rules="[v => !!v || 'กรุณากรอกราคาขาย(ต่อชุด)']" hide-details="auto" required outlined></v-text-field>
                </div>
                <div class="ml-3 mr-1 mt-7">
                  <v-select color="#86bc3a" :items="promotion_list" item-text="show_promotion_name" item-value="show_promotion_id" :rules="[v => !!v || 'กรุณาเลือกสถานะแสดงการขาย']" v-model="header_list.show_promotion_set" label="สถานะแสดงการขาย" hide-details="auto" required outlined/>
                </div>
              </div>
              <div class="grid_full">
                <div class="ml-3 mt-7 mr-1">
                  <v-textarea color="#86bc3a" label="รายละเอียด" :rules="[v => !!v || 'กรุณากรอกรายละเอียด']" v-model="header_list.detail" hide-details="auto" required outlined></v-textarea>
                </div>
              </div>
            </div>
          </div>
          <div class="pa-4">
            <v-card-title>
              <div>
                สินค้าในเงื่อนไข
              </div>
            </v-card-title>
            <v-card-title>
              <v-autocomplete clearable @input="addProductList()" color="#86bc3a" :items="getProduct" item-text="product_name" item-value="product_id" v-model="select_1" prepend-inner-icon="mdi-cart-outline" label="สินค้า" hide-details="auto" outlined/>
            </v-card-title>
            <v-data-table :headers="headers" :items="data_list" :footer-props="footer_Props" :items-per-page="per_page" mobile-breakpoint="0">
              <template v-slot:item="dataDetail">
                <tr>
                  <td>{{ dataDetail.item.product_name }}</td>
                  <td>{{ format_price(dataDetail.item.cost_avg) }}</td>
                  <td>{{ dataDetail.item.unit_name }}</td>
                  <td class="pa-3">
                    <v-btn small height="42" @click="getDelete(dataDetail.item.loop_id, dataDetail.item.id, dataDetail.item.product_id)" class="grad-danger-bg white--text mb-1">
                      <v-icon>mdi-delete-empty-outline</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
            <div class="text-center mt-4 pb-4">
              <v-btn height="45" class="white--text grad-success-bg btn_size" type="submit">บันทึกข้อมูล</v-btn>
            </div>
          </div>
        </v-form>
      </v-card>
    </div>
  </div>
</template>

<script>
import header_promotion_name from "@/components/admin/stock/storage_promotion/header_promotion/header_promotion_name";
import img_holder from "@/assets/pharmacy.png";
import HeaderImage from "@/assets/boxes_random.png";
import {formatPrice, minDate, onlyForCurrency, onlyForNumber} from "@/js/handler";
import {HTTP} from "@/axios";
import Swal from "sweetalert2";
export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Promotion_edit_group",
  components: {
    header_promotion_name
  },
  data() {
    return {
      loading_page: false,
      img_holder: img_holder,
      header_image: HeaderImage,
      pro_pic_name: null,
      imagePreviewURL: null,
      menu_date: false,
      alert_danger: false,
      alert_success: false,
      date: '',
      dateEN: '',
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text':'รายการต่อหน้า'
      },
      per_page: -1,
      start_date: this.min_date(),
      select_1: null,
      headers: [
        {
          text: 'ชื่อสินค้า',
          value: 'product_name',
          fixed: true,
          width: '500px',
        },
        {
          text: 'ราคาต้นทุนเฉลี่ย',
          value: 'cost_avg',
          fixed: true,
          width: '200px',
        },
        {
          text: 'หน่วยนับ',
          value: 'unit',
          fixed: true,
          width: '200px',
        },
        {
          text: 'จัดการ',
          value: '',
          sortable: false,
          fixed: true,
          width: '100px',
        },
      ],
      promotion_list: [
        {
          show_promotion_id: '1',
          show_promotion_name: 'แสดงทั้งขายปลีก , ขายส่ง',
        },
        {
          show_promotion_id: '2',
          show_promotion_name: 'แสดงเฉพาะขายปลีก',
        },
        {
          show_promotion_id: '3',
          show_promotion_name: 'แสดงเฉพาะขายส่ง',
        },
      ],
      header_list: [],
      data_list: [],
      loop_id: 0,
      getProduct: [],
      selected_arr: [],
    }
  },
  methods: {
    min_date: function () {
      return minDate()
    },
    async selectDate() {
      this.$refs.menu_date.save(this.date)
      this.menu_date = false
    },
    diffDateTH(value) {
      const diff = value.split('-')
      const day = diff[2]
      const month = diff[1]
      const year = parseInt(diff[0])+ 543
      const final_date = day+'-'+month+'-'+year
      return this.date = final_date
    },
    diffDateEN() {
      const diff = this.date.split('-')
      const year = parseInt(diff[2]) - 543
      const month = diff[1]
      const day = diff[0]
      return year+'-'+month+'-'+day
    },
    format_price: function (value) {
      return formatPrice(value)
    },
    isOnlyNumber: function (evt) {
      return onlyForNumber(evt)
    },
    isCurrency: function (evt, number) {
      return onlyForCurrency(evt, number)
    },
    onFileChange(payload) {
      const file = payload
      if (file) {
        this.header_list.pic = URL.createObjectURL(file)
        URL.revokeObjectURL(file)
      } else {
        this.header_list.pic = ''
      }
    },
    get_product_list() {
      this.getProduct = []
          HTTP.post('/inventory/promotions/sets/getproducts')
          .then((res) => {
            if (res.data.success === true) {
              res.data.object.forEach((data) => {
                let inc = this.selected_arr.includes(data.product_id)
                if (inc === false) {
                  this.getProduct.push({
                    cost: data.cost,
                    cost_avg: data.cost_avg,
                    created_at: data.created_at,
                    date_expired: data.date_expired,
                    discount_percent: data.discount_percent,
                    discount_price: data.discount_price,
                    discount_unit: data.discount_unit,
                    exchange_status: data.exchange_status,
                    import_id: data.import_id,
                    lot_no: data.lot_no,
                    po_id: data.po_id,
                    price: data.price,
                    product_code: data.product_code,
                    product_id: data.product_id,
                    product_name: data.product_name,
                    quantity: data.quantity,
                    status: data.status,
                    supplier: data.supplier,
                    supplier_id: data.supplier_id,
                    unit: data.unit,
                    unit_id: data.unit_id,
                    warehouse_id: data.warehouse_id,
                  })
                }
              })
            }
          })
    },
    async get_data() {
      this.loading_page = true
      await HTTP.post('/inventory/promotions/sets/getbyid', {
        id: this.$route.params.id
      }).then((res) => {
        if (res.data.success === true) {
          this.loading_page = false
          this.header_list = res.data.object.head
          res.data.object.list.forEach((data) => {
            const id = this.loop_id += 1;
            this.data_list.push({
              loop_id: id,
              id: data.id,
              po_id: data.po_id,
              product_id: data.product_id,
              product_name: data.product_name,
              cost_avg: data.cost_avg,
              unit_name: data.unit_name,
              unit_id: data.unit_id,
              warehouse_id: data.warehouse_main_id,
              import_id: data.import_id,
            })
          })
          const pro_id = this.data_list.map((detail) => {
            return detail.product_id
          })
          this.selected_arr = pro_id
          if (res.data.object.head.date_end !== null) {
            this.date = res.data.object.head.date_end
            this.diffDateTH(this.date)
          }
          else {
            this.date = ''
          }
          this.get_product_list()
        }
      })
    },
    async addProductList() {
      const res_1 = this.getProduct.find((details) => {
        return details.product_id === this.select_1
      })
      this.alert_success = true;
      setTimeout(() => this.alert_success = false, 3000);
      const id = this.loop_id += 1;
      this.data_list.push({
        loop_id: id,
        id: null,
        po_id: res_1.po_id,
        product_id: res_1.product_id,
        product_name: res_1.product_name,
        cost_avg: res_1.cost_avg,
        unit_name: res_1.unit,
        unit_id: res_1.unit_id,
        warehouse_id: res_1.warehouse_id,
        import_id: res_1.import_id,
      })
      const find_product = this.data_list.filter(data => data.product_id === this.select_1)
      const map_product = find_product.map(data => data.product_id)
      const pop_id = map_product.pop()
      this.selected_arr.push(pop_id)
      this.get_product_list()
      await this.$nextTick(() => {
        this.select_1 = null;
      })
    },
    async getDelete(loop_id, id, product_id) {
      if (id !== null) {
        await HTTP.post('/inventory/promotions/sets/deletelist', {
          id: id
        }).then((res) => {
          if (res.data.success === true) {
            this.alert_danger = true;
            setTimeout(() => this.alert_danger = false, 3000);
            // re-product
            const find_product = this.data_list.filter(data => data.product_id === product_id)
            const map_product = find_product.map(data => data.product_id)
            const pop_id = map_product.pop()
            const index = this.selected_arr.indexOf(pop_id);
            if (index > -1) {
              this.selected_arr.splice(index, 1);
            }
            this.get_product_list()
            this.data_list = this.data_list.filter(data => data.loop_id !== loop_id)
          }
        })
      }
      else {
        this.alert_danger = true;
        setTimeout(() => this.alert_danger = false, 3000);
        // re-product
        const find_product = this.data_list.filter(data => data.product_id === product_id)
        const map_product = find_product.map(data => data.product_id)
        const pop_id = map_product.pop()
        const index = this.selected_arr.indexOf(pop_id);
        if (index > -1) {
          this.selected_arr.splice(index, 1);
        }
        this.get_product_list()
        this.data_list = this.data_list.filter(data => data.loop_id !== loop_id)
      }
    },
    update_data() {
      if (this.$refs.update.validate()) {
        if (this.data_list.length > 0) {
          if (this.pro_pic_name !== '' && this.pro_pic_name !== null) {
            let extall ="png,PNG,jpeg,JPEG,jpg,JPG";
            let file = this.pro_pic_name.name;
            let ext = file.split('.').pop().toLowerCase();
            if (parseInt(extall.indexOf(ext)) < 0) {
              Swal.fire({
                text: 'อัพโหลดได้เฉพาะไฟล์ รูป หรือ (.png, .PNG, .jpeg, .JPEG, .jpg, .JPG)',
                icon: 'error',
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: `ตกลง`,
                denyButtonText: `ยกเลิก`,
              }).then(() => {
                this.header_list.pic = null
                this.pro_pic_name = null
              })
            }
            else {
              Swal.fire({
                title: 'ต้องการบันทึกการแก้ไขหรือไม่ ?',
                icon: 'warning',
                showDenyButton: true,
                showCancelButton: false,
                confirmButtonText: `ตกลง`,
                denyButtonText: `ยกเลิก`,
              }).then((res) => {
                if (res.isConfirmed === true) {
                  let config = {
                    headers: {
                      'Content-Type': 'multipart/form-data'
                    }
                  };
                  let formData = new FormData();
                  formData.append('image', this.pro_pic_name, this.pro_pic_name.name)
                  formData.append('user_id', this.$store.state.userDetail.id)
                  formData.append('user_name', this.$store.state.userDetail.name)
                  formData.append('promotion_group_date', this.diffDateEN())
                  formData.append('id', this.header_list.id)
                  formData.append('name_group', this.header_list.name)
                  formData.append('qty_group', this.header_list.qty_per_set)
                  formData.append('price_group', this.header_list.price_per_set)
                  formData.append('note_group', this.header_list.detail)
                  formData.append('show_promotion_set', this.header_list.show_promotion_set)
                  formData.append('data_list', JSON.stringify(this.data_list))
                  this.overlay = true
                  this.image_modal = false
                  HTTP.post('/inventory/promotions/sets/update', formData, config)
                      .then((res) => {
                        if (res.data.success === true) {
                          Swal.fire({
                            text: 'แก้ไขข้อมูลสำเร็จ !',
                            icon: 'success',
                            showDenyButton: false,
                            showCancelButton: false,
                            confirmButtonText: `ตกลง`,
                            denyButtonText: `ยกเลิก`,
                          }).then(() => {
                            this.$router.push('/stock/promotion_stock/promotionassorted')
                          })
                        }
                      })
                }
              })
            }
          }
          else {
            Swal.fire({
              title: 'ต้องการบันทึกการแก้ไขหรือไม่ ?',
              icon: 'warning',
              showDenyButton: true,
              showCancelButton: false,
              confirmButtonText: `ตกลง`,
              denyButtonText: `ยกเลิก`,
            }).then((res) => {
              if (res.isConfirmed === true) {
                let config = {
                  headers: {
                    'Content-Type': 'multipart/form-data'
                  }
                };
                let formData = new FormData();
                formData.append('user_id', this.$store.state.userDetail.id)
                formData.append('user_name', this.$store.state.userDetail.name)
                formData.append('promotion_group_date', this.diffDateEN())
                formData.append('id', this.header_list.id)
                formData.append('name_group', this.header_list.name)
                formData.append('qty_group', this.header_list.qty_per_set)
                formData.append('price_group', this.header_list.price_per_set)
                formData.append('note_group', this.header_list.detail)
                formData.append('show_promotion_set', this.header_list.show_promotion_set)
                formData.append('data_list', JSON.stringify(this.data_list))
                this.overlay = true
                this.image_modal = false
                HTTP.post('/inventory/promotions/sets/update', formData, config)
                    .then((res) => {
                      if (res.data.success === true) {
                        Swal.fire({
                          text: 'แก้ไขข้อมูลสำเร็จ !',
                          icon: 'success',
                          showDenyButton: false,
                          showCancelButton: false,
                          confirmButtonText: `ตกลง`,
                          denyButtonText: `ยกเลิก`,
                        }).then(() => {
                          this.$router.push('/stock/promotion_stock/promotionassorted')
                        })
                      }
                    })
              }
            })
          }
        }
        else {
          Swal.fire({
            title: 'ไม่สามารถดำเนินการได้ !',
            text: 'เนื่องจาก ไม่มีข้อมูลหรือไม่ได้เลือกสินค้า !',
            icon: 'error',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          })
        }
      }
      else {
        Swal.fire({
          title: 'ไม่สามารถดำเนินการได้ !',
          text: 'เนื่องจาก ไม่มีข้อมูลหรือไม่ได้เลือกสินค้า !',
          icon: 'error',
          showDenyButton: false,
          showCancelButton: false,
          confirmButtonText: `ตกลง`,
          denyButtonText: `ยกเลิก`,
        })
      }
    },
  },
  mounted() {
    this.get_data()
  }
}
</script>

<style scoped>
.grid_half {
  display: grid;
  grid-template-columns: 30% 70%;
}
.grid_list {
  display: grid;
  grid-template-columns: 50% 50%;
}
.grid_full {
  display: grid;
  grid-template-columns: 100%;
  grid-gap: 15px 0;
}
.btn_size {
  font-size: 18px;
}
.preview {
  border-radius: 8px;
}
@media only screen and (max-width: 1100px) {
  .grid_half {
    display: grid;
    grid-template-columns: 100%;
  }
}
@media only screen and (max-width: 600px) {
  .grid_half {
    display: grid;
    grid-template-columns: 100%;
  }
  .grid_list {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
  .grid_full {
    display: grid;
    grid-template-columns: 100%;
    margin-top: 40px;
  }
}
</style>
